module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-queen.48ce3311.jpg";